module.exports = __webpack_public_path__ + "static/img/memories_ttl.a08615b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/memories_ttl.svg
// module id = JIuv
// module chunks = 0